const ADMIN_CSRF_TOKEN_KEY = 'adminCsrfToken';

function getSessionStorage(): Storage | null {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.sessionStorage;
}

export function readAdminCsrfToken(): string {
  return getSessionStorage()?.getItem(ADMIN_CSRF_TOKEN_KEY) ?? '';
}

export function storeAdminCsrfToken(token: string): void {
  getSessionStorage()?.setItem(ADMIN_CSRF_TOKEN_KEY, token);
}

export function clearAdminCsrfToken(): void {
  getSessionStorage()?.removeItem(ADMIN_CSRF_TOKEN_KEY);
}
